
import React, { useState, useEffect } from 'react';
import { Check, Trash2 } from 'lucide-react';


// Toast Notification Component
const Toast = ({ message, type = 'success', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const bgColor = type === 'success' ? 'bg-green-500' : 'bg-red-500';
  
  return (
    <div className={`fixed bottom-6 right-6 ${bgColor} text-white px-6 py-4 rounded-xl shadow-2xl z-50 animate-slide-up flex items-center space-x-3`}>
      {type === 'success' ? <Check className="w-5 h-5" /> : <Trash2 className="w-5 h-5" />}
      <span className="font-medium">{message}</span>
    </div>
  );
};
export default Toast;